import React, { useMemo } from 'react';
import { Grid, MenuItem, Divider, Typography, Button, Box } from '@mui/material';
import { styles } from './styles';
import { Plus } from '../../../assets/icons/plus';
import { Remove } from '../../../assets/icons/remove';
import TextField from '../../../components/common/InputField/TextField';

const UserRoles = (props) => {
    const { roles, companies, selectedCompanyRole, setSelectedCompanyRole, errors, touched } = props;

    const handleAdd = () => {
        setSelectedCompanyRole([
            ...selectedCompanyRole,
            {
                company: null,
                role: null,
            },
        ]);
    };

    const handleChange = (index, value, type) => {
        const updated = [...selectedCompanyRole];
        updated[index] = { ...updated[index], [type]: value };
        setSelectedCompanyRole(updated);
    };

    const handleRemove = (index) => {
        const updated = [...selectedCompanyRole];
        updated.splice(index, 1);
        setSelectedCompanyRole(updated);
    };

    const filteredCompanies = useMemo(() => {
        const selectedCompany = selectedCompanyRole.map((item) => item.company);
        return companies.filter((item) => selectedCompany.indexOf(item.name) < 0);
    }, [selectedCompanyRole, companies]);

    return (
        <>
            <Grid
                item
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    pb: '24px',
                }}
            >
                <Typography>User Roles (Required)</Typography>
                <Button
                    color="primary"
                    onClick={() => handleAdd(true)}
                    size="large"
                    variant="text"
                    startIcon={<Plus />}
                >
                    Add User Role
                </Button>
            </Grid>
            <Grid container pl="32px">
                {selectedCompanyRole.map((item, index) => (
                    <Grid container spacing={6} pt="24px">
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Company"
                                name="customer"
                                value={item.company}
                                error={Boolean(touched?.[index]?.company && errors?.[index]?.company)}
                                helperText={touched?.[index]?.company && errors?.[index]?.company}
                                onChange={(event) => handleChange(index, event.target.value, 'company')}
                                select
                            >
                                {[item.company, ...filteredCompanies].map((company) => (
                                    <MenuItem key={company?.id || company} value={company?.name || company}>
                                        {company?.name || company}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={4}>
                            <TextField
                                fullWidth
                                label="Role"
                                name="role"
                                value={item.role}
                                error={Boolean(touched?.[index]?.role && errors?.[index]?.role)}
                                helperText={touched?.[index]?.role && errors?.[index]?.role}
                                onChange={(event) => handleChange(index, event.target.value, 'role')}
                                select
                            >
                                {roles
                                    .filter((role) => role.authority !== 'ROLE_SUPER_ADMINISTRATOR')
                                    .map((role) => (
                                        <MenuItem key={role.id} value={role.authority}>
                                            {role.displayName}
                                        </MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        {selectedCompanyRole.length > 1 && (
                            <Grid item xs={4}>
                                <Box sx={styles.removeButtonBox}>
                                    <Button
                                        onClick={() => handleRemove(index)}
                                        size="large"
                                        sx={styles.removeButton}
                                        variant="text"
                                        startIcon={<Remove />}
                                    >
                                        Remove
                                    </Button>
                                </Box>
                            </Grid>
                        )}
                    </Grid>
                ))}
            </Grid>
            <Grid item sx={styles.dividerWrapper}>
                <Divider flexItem orientation="horizontal" sx={styles.divider} />
            </Grid>
        </>
    );
};

export default React.memo(UserRoles);
